import { Component, inject, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon'; // MatIconModule importieren
import { buildInfo } from '../../../files/build-info';
import { environment } from '../../../environments/environment';
import { StateSnackBarService } from '../../services/state-snack-bar.service';
import { AppUpdateService } from '../../services/app-update.service';

interface BackendInfo {
  version: string;
  time: string;
}

@Component({
  selector: 'app-info-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatProgressSpinnerModule, MatButtonModule, MatIconModule],
  templateUrl: './info-dialog.component.html',
  styleUrls: ['./info-dialog.component.scss'],
})
export class InfoDialogComponent implements OnInit {
  frontendInfo = buildInfo;
  backendInfo: BackendInfo | null = null;
  isLoading = true;

  private apiUrl = environment.backend + '/info';

  private stateSnackbarService = inject(StateSnackBarService);
  public updateService = inject(AppUpdateService);

  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    this.http.get<BackendInfo>(`${this.apiUrl}/backend`).subscribe({
      next: (data) => {
        this.backendInfo = data;
        this.isLoading = false;
      },
      error: () => {
        this.backendInfo = { version: 'Fehler', time: 'Nicht erreichbar' };
        this.isLoading = false;
      },
    });
  }

  reloadPage(): void {
    this.stateSnackbarService.info({ message: 'Seite wird neu geladen...' });
    window.location.reload();
  }
}
